var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.55021 4.21301C1.26093 4.49703 1.26093 4.95751 1.55021 5.24153L7.47614 11.787C7.76541 12.071 8.23442 12.071 8.5237 11.787L14.4496 5.24153C14.7389 4.95752 14.7389 4.49703 14.4496 4.21301C14.1603 3.929 13.6913 3.929 13.4021 4.21301L7.99992 10.2442L2.59778 4.21301C2.3085 3.929 1.83949 3.929 1.55021 4.21301Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/arrow_down.76a506260e19ad19a1b5320b826684c6.svg";
export { ForwardRef as ReactComponent };